const PRIMARY_FAMILIES = Object.freeze([
  { key: 'moneyline', label: 'Moneyline' },
  { key: 'spread', label: 'Spread / Run Line' },
  { key: 'total', label: 'Total' },
])

function marketFamily(market) {
  if (market?.betType === 'Moneyline') return 'moneyline'
  if (['Spread', 'Run Line', 'Puck Line', 'Handicap'].includes(market?.betType)) return 'spread'
  if (market?.betType === 'Total') return 'total'
  return 'other'
}

function cells(market) {
  return Object.values(market?.cells || {}).flatMap((byBook) => Object.values(byBook || {}))
}

function primarySignals(market) {
  return cells(market).filter((cell) => cell?.row?.is_primary === true).length
}

function completeBookCount(market) {
  return Math.max(0, ...Object.values(market?.fair?.bySelection || {}).map((item) => item?.bookCount || 0))
}

function compareMarkets(left, right) {
  return primarySignals(right) - primarySignals(left)
    || completeBookCount(right) - completeBookCount(left)
    || right.books.length - left.books.length
    || right.rowCount - left.rowCount
    || Number(left.line ?? 0) - Number(right.line ?? 0)
    || left.key.localeCompare(right.key)
}

export function buildLiveOddsEventBoard(matrix) {
  const events = (matrix?.events || []).map((event) => {
    const selected = new Set()
    const primaryMarkets = PRIMARY_FAMILIES.map((definition) => {
      const candidates = event.markets.filter((market) => market.period === 'Game' && marketFamily(market) === definition.key)
        .sort(compareMarkets)
      const market = candidates[0] || null
      if (market) selected.add(market.key)
      return { ...definition, available: Boolean(market), market }
    })
    const alternateMarkets = event.markets.filter((market) => !selected.has(market.key))
    const primaryBooks = new Set(primaryMarkets.flatMap((item) => item.market?.books || []))
    return {
      ...event,
      primaryMarkets,
      alternateMarkets,
      primaryBooks: event.books.filter((book) => primaryBooks.has(book)),
      availablePrimaryCount: primaryMarkets.filter((item) => item.available).length,
      moneylineAvailable: primaryMarkets[0].available,
    }
  })
  return {
    events,
    counts: {
      events: events.length,
      moneylineEvents: events.filter((event) => event.moneylineAvailable).length,
      primaryMarkets: events.reduce((sum, event) => sum + event.availablePrimaryCount, 0),
      alternateMarkets: events.reduce((sum, event) => sum + event.alternateMarkets.length, 0),
    },
  }
}

export { PRIMARY_FAMILIES }
